/**
 * Validates if a postMessage origin is trusted.
 * Trusted origins:
 * - *.cardlytics.com subdomains (including local.cardlytics.com) with optional port
 * - localhost and 127.0.0.1 with any port (for development)
 */
export const isTrustedOrigin = (origin: string): boolean => {
  const cardlyticsRegex =
    /^https?:\/\/([\da-z]([\da-z-]*[\da-z])?\.)*cardlytics\.com(:\d+)?$/i;

  const localhostRegex = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/;

  return cardlyticsRegex.test(origin) || localhostRegex.test(origin);
};
